import { toast } from "react-toastify";
import { useAuth } from "../auth/AuthProvider";
import { usePermissionStore } from "../store/usePermissionStore";
import { useMemo } from "react";

export const usePermissions = () => {
  const { user } = useAuth();
  const { permissions } = usePermissionStore();

  const isAdmin =
    user?.roles.includes("orgadmin") || user?.roles.includes("superadmin");

  const hasPermission = useMemo(() => {
    return  (module: string, action: string = "read") => {
      if (isAdmin) return true;

      const actions = permissions[module];
      return actions?.has(action);
    };
  }, [permissions, isAdmin])

  const withPermission = (
    module: string,
    action: string,
    onSuccess: () => void
  ) => {
    if (hasPermission(module, action)) {
      onSuccess();
    } else {
      toast.error("You do not have permission to perform this action.");
    }
  };

  return {
    hasPermission,
    withPermission,
    canRead: (module: string) => hasPermission(module, "read"),
    canUpdate: (module: string) => hasPermission(module, "update"),
    canCreate: (module: string) => hasPermission(module, "create"),
    canDelete: (module: string) => hasPermission(module, "delete"),
  };
};
